export const parseNotificationId = (value: unknown): number | null => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return Math.trunc(value);
  }

  if (typeof value === 'string') {
    const parsed = Number.parseInt(value, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  return null;
};

export const uuidToNotificationId = (value: unknown): number | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.replace(/[^0-9a-f]/gi, '').slice(-12);
  if (!normalized) {
    return null;
  }

  const parsed = Number.parseInt(normalized, 16);
  if (!Number.isFinite(parsed) || Number.isNaN(parsed)) {
    return null;
  }

  const absolute = Math.max(1, parsed);
  return -absolute;
};

export const toNotificationDate = (value?: string | Date | null): Date => {
  if (!value) {
    return new Date();
  }

  if (value instanceof Date) {
    return value;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? new Date() : parsed;
};
